export default class CameraPosition {
    positionX = null;
    positionX = null;
    positionX = null;
    rotationX = null;
    rotationX = null;
    rotationX = null;
    order = null;
    isEuler = null;

    constructor(camera){
        this.positionX = camera.position.x,
        this.positionY = camera.position.y,
        this.positionZ = camera.position.z,
        this.rotationX = camera.rotation.x,
        this.rotationY = camera.rotation.y,
        this.rotationZ = camera.rotation.z,
        this.order = camera.rotation.order,
        this.isEuler = camera.rotation.isEuler
    }
}